import React from 'react';
import { useSelector } from 'react-redux';

const ViewProfile = () => {

    const { user } = useSelector(state => state.updateProfile);

    return (
      <div className="col-lg-4 col-md-12">
        <div className="card profile-header">
            <div className="body text-center">
                <div className="profile-image mb-3"><img  style={{"height" : "150px", "width": "150px"}} src={user?.profile_pic_url} className="rounded-circle" alt=""/></div>
                <div>
                    <h4 className="mb-0"><strong>{user?.first_name } </strong> {user?.last_name}</h4>
                </div>
            </div>
        </div>

        <div className="card">
            <div className="header">
                <h2>Info</h2>
            </div>
            <div className="body">
                <small className="text-muted">Email address: </small>
                <p>{user?.email}</p>                            
                <hr></hr>
                <small className="text-muted">Mobile: </small>
                <p> {user?.contact_no}</p>
                <hr></hr>
               
            </div>
        </div>
      </div>
    )
}
export default ViewProfile;